import { Injectable } from '@angular/core';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationProfileService {

  constructor(private rest : RestService) { }

  public addNotificationProfile(payload: any) { 
    return this.rest.post("addNotificationProfile", payload, null);
  }
  public updateNotificationProfile(payload: any) { 
    return this.rest.put("updateNotificationProfile", payload);
  }

  public deleteNotificationProfile(payload: any) { 
    return this.rest.delete("deleteNotificationProfile", payload);
  }

  public getNotificationProfile() { 
    return this.rest.get("getNotificationProfile", null);
  }

}
